export default __webpack_public_path__ + "static/fun-lounge-255365bf83d58363b2b106d0a04d4912.jpg";